import { combineEpics } from 'redux-observable';
import NotificationTemplatesEpics from './NotificationTemplates/epics';

export default combineEpics(NotificationTemplatesEpics);
